import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { PARAM_1 } from '../../constants/common/common.constants';
import {
  DEFAULT_TIMEOUT,
  HttpRequestMethods,
  IDP_APPS
} from '../../constants/utils';
import { HEADER_FEATURES } from '../../constants/utils/app.constants';
import { HEADER_FOOTER_MOCKS } from '../../mocks/header-footer-mach-core';
import { HeaderFooterMachCore } from '../../models/header-footer-mach-core';
import { ReplaceItem } from '../../models/utils';
import { UrlUtil } from '../../utils/url/urlUtil';
import {
  ApiBuilder,
  AppConfigService,
  CookieHelperService,
  handleError,
  LoggingService
} from '../utils';

@Injectable({
  providedIn: 'root'
})
export class HeaderFooterMachCoreContentService {
  http = inject(HttpClient);
  appConfigService = inject(AppConfigService);
  cookieHelperService = inject(CookieHelperService);
  urlUtil = inject(UrlUtil);
  loggingService = inject(LoggingService);
  headerFooterMachCoreJson$!: Observable<HeaderFooterMachCore>;

  _errorHandler = handleError.bind(this);

  getHeaderFooterMachCoreContent$(): Observable<HeaderFooterMachCore> {
    if (this.headerFooterMachCoreJson$) {
      return this.headerFooterMachCoreJson$;
    } else {
      this.headerFooterMachCoreJson$ = this.init().pipe(shareReplay(1));
      return this.headerFooterMachCoreJson$;
    }
  }

  private init(): Observable<HeaderFooterMachCore> {
    const headerFooterURL: ReplaceItem[] = [
      {
        src: PARAM_1,
        target:
          this.urlUtil.getCountryCodeForUrl(
            this.cookieHelperService.getCountryCode()
          ) ||
          this.appConfigService.getConfig('HEADER')?.['APP_DEFAULT_COUNTRY'] ||
          'us'
      }
    ];

    return new ApiBuilder<undefined, HeaderFooterMachCore>(
      this.http,
      this.appConfigService
    )
      .app(IDP_APPS.HEADER)
      .endpointKey('HEADER_FOOTER_MACH_CORE')
      .overrideEndpoint(headerFooterURL)
      .method(HttpRequestMethods.GET)
      .errorHandler(this._errorHandler)
      .timeOut(DEFAULT_TIMEOUT)
      .library(HEADER_FEATURES.HEADER_FOOTER_MACH_CORE)
      .create()
      .pipe(
        map((response: HeaderFooterMachCore) => {
          return response;
        }),
        catchError((err) => {
          this.loggingService.log(
            `Mach Core content json loading failed: ${err}`
          );
          return of(HEADER_FOOTER_MOCKS);
        })
      );
  }
}
